import React from 'react';
import InfoItem from './InfoItem';
import IconItem from './IconItem';

const CommunicationMethods = ({ p }) => {
  let communication = [];

  if (p.messageCommunication) {
    communication.push('Text messaging');
  }
  if (p.emailCommunication) {
    communication.push('Email');
  }
  if (p.videoCommunication) {
    communication.push('Videochat');
  }
  if (p.cellCommunication) {
    communication.push('Cell phone calls');
  }
  if (p.homeVisits) {
    communication.push('Home visits');
  }

  if (communication.length === 0) return null;
  return (
    <InfoItem title="Physician communication">
      {communication.map((ben, i) => (
        <IconItem icon={'check'} key={i}>
          {' '}
          <p>{ben}</p>
        </IconItem>
      ))}
    </InfoItem>
  );
};

export default CommunicationMethods;
